import { RootState, useAppDispatch, useAppSelector } from 'common';
import { RecipeHeader } from 'common/src/api/models/recipe-header.models';
import { getRecipeHeaders, selectHiddenRecipesGridData } from 'common/src/store/recipes';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CfDataGridProps } from '../../../../cf-ui/DataGrid/CfDataGridProps';
import { CfDataGridContainer } from '../../../../cf-ui/DataGridContainer/CfDataGridContainer';
import { StyledViewBox } from '../../../_shared/components/shared-styled-components.styles';
import { hiddenRecipesTableView } from '../../components/gridTablesView/HiddenRecipesTableView';
import { ManageAccessTableHeader } from '../../components/headers/ManageAccessTableHeader';
import HiddenRecipesDialog, { HiddenRecipesDialogProps } from '../../dialogs/HiddenRecipesDialog';

export default function HiddenRecipes(): JSX.Element {
  const dispatch = useAppDispatch();
  const { customerId } = useParams<{ customerId: string }>();

  const [searchParam, setSearchParam] = useState('');
  const [showManageHiddenRecipes, setShowManageHiddenRecipes] = useState<HiddenRecipesDialogProps | undefined>(
    undefined
  );

  const filteredHiddenRecipes = useAppSelector((s: RootState) => selectHiddenRecipesGridData(s, searchParam));
  const isRecipeHeadersLoading = useAppSelector((s: RootState) => s.recipes.isRecipeHeadersLoading);

  useEffect(() => {
    dispatch(getRecipeHeaders(customerId));
  }, []);

  const handleDialog = () => {
    setShowManageHiddenRecipes({ onClose: () => setShowManageHiddenRecipes(undefined) });
  };

  const dataGridProps: CfDataGridProps<RecipeHeader> = {
    id: 'recipeWorkSheetGrid',
    tableView: hiddenRecipesTableView(),
    selectId: (item: RecipeHeader) => item.RecipeHeaderId,
    displayMode: 'table',
    autoFocus: 'firstNavigableElement',
    noItemsMessage: 'No recipes found',
    data: {
      pages: [
        {
          pageIndex: 0,
          isLoading: isRecipeHeadersLoading,
          items: filteredHiddenRecipes,
          pageSize: filteredHiddenRecipes.length,
        },
      ],
      totalPageCount: 1,
      totalItemCount: filteredHiddenRecipes.length,
      pagingMode: 'none',
    },
  };

  return (
    <StyledViewBox sx={{ pt: 2 }}>
      <CfDataGridContainer
        dataGridProps={dataGridProps}
        sx={{
          '& .css-nsyoup-MuiCardContent-root': {
            padding: 0,
            margin: 0,
          },
        }}
        controlsContainerSx={{ padding: 0, margin: 0 }}
        customControlsContainer={
          <ManageAccessTableHeader
            title='Hidden recipes'
            description='Hidden recipes are not visible to locations with access to view all recipes.'
            searchPlaceholder='Search recipes'
            setSearchParam={setSearchParam}
            handleDialog={handleDialog}
            isHiddenRecipes={true}
          />
        }
      />
      {showManageHiddenRecipes && <HiddenRecipesDialog {...showManageHiddenRecipes} />}
    </StyledViewBox>
  );
}
